import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d8e8d94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "business-notice-list" }
const _hoisted_2 = {
  key: 0,
  role: "alert",
  class: "business-notice-error"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "business-notice-actions" }

import {captureOperationFeedback} from '@/utils/operationFeedback'

import {computed,onBeforeUnmount,ref,watch} from 'vue'
import store from '@/store'
import router from '@/router'
import request from '@/utils/request'
import {BusinessNotice,notificationBatch,unreadNotices} from '@/utils/notificationBatch'
import {claimPopup,releasePopup,popupAvailable} from '@/utils/popupDisplay'

export default /*#__PURE__*/_defineComponent({
  __name: 'BusinessNotification',
  props: {
    admin: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {admin?:boolean};

const owner={}
const items=ref<BusinessNotice[]>([]),busy=ref(false),error=ref(''),remaining=ref(0)
const identity=computed(()=>{const user=store.getters.userInfo;return store.getters.token&&user?.id&&(props.admin||Number(user.orgId)===Number(store.getters.orgId))?[props.admin?'org':'cus',user.orgId,user.id,store.getters.token].join(':'):''})
const endpoint=()=>props.admin?'system':'customer'
const center=()=>props.admin?'/system/messages':'/main/cuscenter/security-notifications'
let generation=0,loading=false,disposed=false,presented=false
let previewBusy=false
const allowed=computed(()=>!!identity.value&&router.currentRoute.value.path!==center()&&!/orderconfirm|upgradeLevel|buycourse|login|makingorder|makingBoke/i.test(router.currentRoute.value.path))
const heading=computed(()=>items.value[0]?.notificationKind==='shipping'?`您有${items.value.length}笔订单已发货`:items.value[0]?.notificationKind==='security'?'账号安全提醒':'消息提醒')
function safe(){return !previewBusy&&allowed.value&&document.visibilityState!=='hidden'&&!/INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName||'')&&popupAvailable(owner,'business-notice-shell')&&!Array.from(document.querySelectorAll('.ant-modal-wrap:not(.business-notice-shell),.ant-drawer-open')).some(el=>el.getClientRects().length>0&&getComputedStyle(el).visibility!=='hidden')}
function clear(){items.value=[];error.value='';releasePopup(owner)}
async function check(){
 if(disposed||loading||busy.value||!identity.value||!allowed.value||document.visibilityState==='hidden')return
 const run=generation,who=identity.value;loading=true
 try{const response=await request({url:endpoint()+'/securityNotifications',method:'GET',params:{unreadOnly:true},quietNotification:true} as any)
  if(disposed||run!==generation||who!==identity.value)return
  const unread=unreadNotices(response.data?.items)
  if(!props.admin)window.dispatchEvent(new CustomEvent('customer-notification-count',{detail:{identity:[store.getters.userInfo?.orgId,store.getters.userInfo?.id].join(':'),count:Number(response.data?.unreadCount)||0}}))
  if(items.value.length){items.value=items.value.filter(x=>unread.some(y=>y.id===x.id));if(!items.value.length)clear();return}
  if(presented||!safe())return
  const group=notificationBatch(unread,props.admin);if(!group.length||!claimPopup(owner,'business-notice-shell'))return
  items.value=group;remaining.value=unread.length-group.length;presented=true
 }catch{/* 读取失败不修改确认状态，下次重试。 */}finally{if(run===generation)loading=false}
}
async function mark(selected:BusinessNotice[]){const who=identity.value,run=generation;for(const item of selected){if(!who||who!==identity.value||run!==generation)throw Error('账号已变化，请重新查看通知');await request({url:endpoint()+'/securityNotifications/read',method:'POST',data:{id:item.id},quietNotification:true} as any)}if(who===identity.value&&run===generation){items.value=items.value.filter(x=>!selected.some(y=>y.id===x.id));if(!items.value.length)clear();window.dispatchEvent(new CustomEvent(props.admin?'admin-notifications-changed':'customer-notifications-changed',{detail:{identity:[store.getters.userInfo?.orgId,store.getters.userInfo?.id].join(':')}}))}}
async function confirm(){const reportOperationIssue=captureOperationFeedback();if(busy.value)return;busy.value=true;error.value='';try{await mark([...items.value])}catch{{error.value='确认未完成，请重试；通知仍保留。';reportOperationIssue(error.value)}}finally{busy.value=false}}
function destination(item:BusinessNotice){if(props.admin)return center();const id=String(item.targetId||'');if(!/^[1-9]\d*$/.test(id))return center()+'?noticeId='+item.id;if(item.targetType==='drawing')return '/main/cuscenter/drawing-patterns?id='+id;if(item.targetType==='order'){const type=Number(item.orderType);if([1,2,5,6,7].includes(type))return '/main/cuscenter/orderconfirm?id='+id+'&orderType='+type;if([3,4,8,9,10,11].includes(type))return '/main/cuscenter/clothorderconfirm?id='+id}return center()+'?noticeId='+item.id}
async function view(item:BusinessNotice){const reportOperationIssue=captureOperationFeedback();if(!item||busy.value)return;busy.value=true;const who=identity.value;error.value='';try{const path=destination(item);const result=await router.push(path);if(result&&router.currentRoute.value.fullPath!==router.resolve(path).fullPath)throw Error();if(who!==identity.value)throw Error();if(!path.startsWith(center()))await mark([item]);clear()}catch{{error.value='暂时无法查看，请重试。';reportOperationIssue(error.value)}}finally{busy.value=false}}
async function openCenter(){const reportOperationIssue=captureOperationFeedback();try{const result=await router.push(center());if(!result)clear()}catch{{error.value='消息中心暂时无法打开，请重试。';reportOperationIssue(error.value)}}}
function reset(){generation++;loading=false;busy.value=false;presented=false;clear();void check()}
function visibility(){if(document.visibilityState==='hidden'){generation++;loading=false;clear()}else reset()}
watch(identity,reset,{immediate:true});watch(allowed,value=>{if(!value)clear();else void check()})
const timer=window.setInterval(()=>{void check()},15000)
const localPreview=['127.0.0.1','localhost'].includes(location.hostname)&&new URLSearchParams(location.search).get('noticeExperience')==='1'
const previewReset=()=>{if(localPreview)reset()}
async function restorePreviewNetwork(){if(localPreview)await request({url:endpoint()+'/notificationPreview',method:'POST',data:{scenario:'restore'},quietNotification:true} as any)}
const previewPause=(event:Event)=>{if(localPreview){previewBusy=!!(event as CustomEvent).detail;if(!previewBusy)void check()}}
if(localPreview){window.addEventListener('business-notice-preview-reset',previewReset);window.addEventListener('business-notice-preview-busy',previewPause)}
document.addEventListener('visibilitychange',visibility)
onBeforeUnmount(()=>{disposed=true;generation++;clearInterval(timer);document.removeEventListener('visibilitychange',visibility);window.removeEventListener('business-notice-preview-reset',previewReset);window.removeEventListener('business-notice-preview-busy',previewPause);releasePopup(owner)})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: items.value.length>0 && _unref(allowed),
    title: _unref(heading),
    width: 420,
    footer: null,
    centered: "",
    closable: false,
    "mask-closable": false,
    keyboard: false,
    "wrap-class-name": "business-notice-shell"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
          return (_openBlock(), _createElementBlock("article", {
            key: item.id
          }, [
            _createElementVNode("p", null, _toDisplayString(item.message), 1),
            (items.value.length>1)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "link",
                  disabled: busy.value,
                  onClick: ($event: any) => (view(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.actionText||'查看订单'), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
      (error.value && _unref(localPreview))
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            onClick: restorePreviewNetwork
          }, {
            default: _withCtx(() => [
              _createTextVNode("恢复模拟网络")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (remaining.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "另有" + _toDisplayString(remaining.value) + "条通知，可到消息中心查看。", 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_button, {
          loading: busy.value,
          onClick: confirm
        }, {
          default: _withCtx(() => [
            _createTextVNode("知道了")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_a_button, {
          type: "primary",
          disabled: busy.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (items.value.length>1?openCenter():view(items.value[0])))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(items.value.length>1?'查看发货订单':items.value[0]?.actionText||'查看通知'), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})